import {NamaRouterInstance} from "../routing/NamaRouter";
import {ajaxJSON, areAllEmptyOrNull} from "../common/NamaCommon";
import * as NamaURLS from "../constants/NamaURLS";
import {appendRow, gridFocusCell, realLineKeys} from "../grid/GridEventsController";
import {translateMessage} from "../common/Translator";
import {stringify} from "../common/NamaJSON";
import * as notifier from "../common/ErrorsNotification";

function fetchOrAddDataItem(grid, paymentLines) {
    let dataItem = grid.currentDataItem();
    if (dataItem)
        return dataItem;
    let mustAddLine = false;
    if (!paymentLines.length)
        mustAddLine = true;
    let realkeys = Object.keys(paymentLines[paymentLines.length - 1]).removeAll(realLineKeys());
    if (realkeys.length)
        mustAddLine = true;
    if (!mustAddLine)
        return grid.dataSource.data()[paymentLines.length - 1];
    let kendoGrid = grid._kendoGrid();
    gridFocusCell(grid, kendoGrid, 0, ":last");
    let newDataItem = {};
    appendRow(kendoGrid, true, grid, false, true, newDataItem);
    return newDataItem;

}

export function payInvoice() {
    let currentPresenter = NamaRouterInstance.currentPresenter;
    if (!currentPresenter)
        return;
    let paymentTerminalRef = currentPresenter.getFieldValue("paymentTerminal");
    let paymentLines = currentPresenter.getFieldValue("paymentLines");
    let grid = currentPresenter.gridWithId("paymentLines");
    let line = fetchOrAddDataItem(grid, paymentLines);
    let port = "7842";
    let valueToPaid = line.paymentValue || currentPresenter.getFieldValue("money.remaining");
    let url = "http://localhost:" + port + "/payInvoice/" + valueToPaid;
    ajaxJSON(url, {}, (resp) => {
        let request = {
            pgwResp: stringify(resp),
            valueToPaid: valueToPaid,
            terminal: stringify(paymentTerminalRef),
        };
        ajaxJSON(NamaURLS.PreparePGWLine, request, (respLine) => {
            line.panNum = respLine.panNum;
            line.stanNum = respLine.stanNum;
            line.terminalId = respLine.terminalId;
            line.schemeId = respLine.schemeId;
            line.merchantId = respLine.merchantId;
            line.ecrRefNum = respLine.ecrRefNum;
            if (areAllEmptyOrNull(respLine.stanNum, respLine.terminalId, respLine.schemeId, respLine.merchantId, respLine.ecrRefNum)) {
                notifier.showError("Purchase Transaction not completed successfully");
                return;
            }
            grid.onColumnChanged("paymentValue", line.paymentValue, line.id);
            grid.onColumnChanged("paymentMethod", line.paymentMethod, line.id);
            line.paymentMethod = respLine.paymentMethod;
            line.paymentValue = respLine.paymentValue;
        })
    }, (error) => {
        notifier.showError("There is no connection on port " + port + ", please make sure that the PGW server is running. You can download the setup file from <a href='https://www.namasoft.com/bin/PGWSetup.msi' target='_blank'>here</a>");
    });
}